/* import router from '@/router'
import Session from '@/models/Session' */

export default {
  /* goToLastDashboard({ commit }) {
    if (router.history.current.name !== 'Dashboard') {
      if (Session.getWorkspaceId())
        router.push({ name: 'Dashboard', params: { workspaceId: Session.getWorkspaceId() } })
      else {
        // FIXME: qui, di default, vorrei andare nel mio private
        commit('toastSet', {
          message: 'Session expired: default routing to workspace settings',
          color: 'warning',
        })
        if (router.history.current.name !== 'Settings') router.push({ name: 'Settings' })
      }
    }
  }, */
}
